import React, { useContext } from "react";
import AuthContext from "../../../services/firebase/auth-context/provider";
import { defaultValues } from "./default-values";
import { CUSTOMER, LEGAL_AGREEMENT } from "./field-names";
import { Form, Formik } from "formik";
import { validationSchema } from "./validation-schema";
import * as styles from "../magazines/form.module.css";
import CustomerDataForm from "../_sub-forms/customer-data/form";
import LegalAgreementForm from "../_sub-forms/legal-agreement/form";
import FormSubmit from "../common/submit";
import NewsletterAgreementForm from "../_sub-forms/newsletter-agreement/form";
import { NEWSLETTER_AGREEMENT } from "../subscribe/field-names";
var FreiexemplarForm = function FreiexemplarForm(_ref) {
    var onSubmit = _ref.onSubmit;
    var _useContext$ = useContext(AuthContext)[0], user = _useContext$.user, authenticated = _useContext$.authenticated; // Set default values
    if (authenticated && user.email)
        defaultValues[CUSTOMER].email = user.email;
    return /*#__PURE__*/ React.createElement(Formik, {
        onSubmit: onSubmit,
        initialValues: defaultValues,
        validationSchema: validationSchema
    }, function (props) {
        return /*#__PURE__*/ React.createElement(Form, null, /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "Pers\xF6nliche Daten"), /*#__PURE__*/ React.createElement(CustomerDataForm, {
            namespace: CUSTOMER,
            hideEmailField: false,
            fieldValues: props.values[CUSTOMER]
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "Newsletter"), /*#__PURE__*/ React.createElement(NewsletterAgreementForm, {
            namespace: NEWSLETTER_AGREEMENT
        })), /*#__PURE__*/ React.createElement("div", {
            className: styles.section
        }, /*#__PURE__*/ React.createElement("h3", {
            className: styles.sectionTitle
        }, "AGB und Datenschutzverarbeitung"), /*#__PURE__*/ React.createElement(LegalAgreementForm, {
            namespace: LEGAL_AGREEMENT,
            privacyNonSubscription: true
        })), /*#__PURE__*/ React.createElement("div", {
            className: "text-center mb-2"
        }, /*#__PURE__*/ React.createElement(FormSubmit, {
            text: /*#__PURE__*/ React.createElement("span", null, "Kostenloses Freiexemplar bestellen"),
            props: props,
            buttonClassName: "btn-makroOrange"
        })));
    });
};
export default FreiexemplarForm;
